import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios } = Request;

const URL = getOrigin("www") + "/xt-message/";

// 获取站内信列表
export function getLetterList(config) {
  return XtAxios.get(`${URL}private/user-letter/list`, config);
}
// 已读
export function letterRead(config) {
  return XtAxios.put(`${URL}private/user-letter/read`, null, config);
}

//获取广告列表
export function getUserLetterList(config) {
  return XtAxios.get(URL + `private/user-letter/list`, config);
}


//获取广告Group
export function getUserLetterGroup(config) {
  return XtAxios.get(URL + `private/user-letter/group`, config);
}

// 全部已读
export function getUserLetterRead(config) {
  return XtAxios.put(URL + `private/user-letter/read`, null, config);
}

export function getUserLetterSingleRead(config, userLetterId) {
  return XtAxios.put(URL + `private/user-letter/read?userLetterId=${userLetterId}`, null, config);
}
// 市场营销设置
export function putUserNoticeConfig(config) {
  return XtAxios.put(URL + `private/user-notice-config`, null, config);
}

export function getUserNoticeConfigList(config) {
  return XtAxios.get(URL + `private/user-notice-config/list`, config);
}